interface Point {
  title: string;
  description: string;
}

interface BentoGridProps {
  title: string;
  quote: string;
  points: Point[];
  isVisible: boolean;
}

export default function BentoGrid({ title, quote, points, isVisible }: BentoGridProps) {
  return (
    <section className="py-32 px-6 bg-gradient-to-b from-[var(--navy-deep)] to-[var(--navy-mid)]">
      <div
        className={`max-w-6xl mx-auto transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <h2 className="text-4xl md:text-5xl font-bold mb-16 text-center">{title}</h2>

        {/* Bento grid */}
        <div className="grid md:grid-cols-3 gap-4">
          {/* Large quote card */}
          <div
            className="md:col-span-2 p-8 rounded-2xl bg-gradient-to-br from-[var(--cyan-electric)]/20 to-[var(--cyan-electric)]/5 border border-[var(--cyan-electric)]/30"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.5s ease',
            }}
          >
            <blockquote className="text-3xl md:text-4xl font-bold italic">
              &ldquo;{quote}&rdquo;
            </blockquote>
          </div>

          {/* Points */}
          {points.map((point, i) => (
            <div
              key={i}
              className="p-6 rounded-2xl bg-white/5 border border-white/10 flex flex-col items-center justify-center text-center hover:bg-white/10 transition-colors"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
                transition: 'all 0.5s ease',
                transitionDelay: `${(i + 1) * 100}ms`,
              }}
            >
              <span className="text-2xl font-bold gradient-text mb-1">{point.title}</span>
              <span className="text-sm text-gray-400">{point.description}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
